const baseUrl = '/api/';
const externalapi = 'https://localhost:56887/api/';
const appUrls = {
  Authentication: {
    user: baseUrl + `auth/login`,
    logout: baseUrl + `auth/logout`,
    refreshToken: baseUrl + `auth/refresh-token`
  },

  account: {
    getAccount: baseUrl +`Account`,
    getAccountLines: baseUrl + `Account/lines`,
    //linesCount: baseUrl + `Account/lines-count`,
    accountBilling: baseUrl + `Account/bills`,
    getAccountTotalGraph: baseUrl + `Account/total-graphs`
  },
  lineDetails: {
    //getLineDetails: baseUrl + `LineDetails/line`,
    getAccountGraphData: baseUrl + `LineDetails/account-graph`,
    getLineStatistics: baseUrl + `LineDetails/line-statistics/`,
    getLineDelayDropGraphsData: baseUrl + `LineDetails/monitor-digest/`,
    getLineGraphsReadings: baseUrl + `LineDetails/graphs-readings/`,

    ccLineSummery: baseUrl + `LineDetails/line-fulldata/`,
    getDevicePingChangesLog: baseUrl + `LineDetails/changes-log`,
    //getDevicePingChangesLogById: baseUrl + `LineDetails/device-ping-changes-log-ById`,
    getDevicePingResult: baseUrl + `LineDetails/ping-results`,
    leasedLinesSummary: baseUrl + `LineDetails/lines-summary`,
    getlineGraph: baseUrl + `LineDetails/line-graph`,
    getlineGraphList: baseUrl + `LineDetails/graph-list/`,
    getGraphStatistics: baseUrl + `LineDetails/graph-statistics/`,
    getHatterasLineStatus: baseUrl + `LineDetails/pairs-status`
  },  
  map: {
     getPopsOfLines: baseUrl + `Map/pops-of-lines`,
     getLinesOfAPop: baseUrl + `Map/lines-of-pop/`,
    getClusteredPops: baseUrl + `Map/account-pops`
  },
  tickets: {
    //getTicketsByLineId: baseUrl +`Tickets/tickets-by-id/`,
    //getTicketsByQuoteId: baseUrl + `Tickets/tickets-by-quote/`
    getTicketsByQuoteIds: baseUrl + `Tickets/get-last-tickets/`,
    createNewTicket: baseUrl + `Tickets/create-new-ticket`,

    //getTicketsByQuoteIds: 'http://10.53.211.110:8010/Tickets/GetLast10Tickets/'
  },
 
  
  EnableLogging: true
}
export default appUrls;
